module.exports = __webpack_public_path__ + "static/media/mariposa-corte-02.eac6012f.png";